import React from 'react';
import { DynamicField, DynamicFieldTypes } from 'src/components/dynamic-widget';
import DynamicFormWidget from 'src/components/dynamic-widget/DynamicFormWidget';
import { DataService } from 'src/services/data-service';
import GenericDialog from 'src/components/GenericDialog';
import { useAppDispatch } from 'src/redux/hooks';
import { showAlert } from 'src/redux/alert/alertReducer';
import { IUserDetails, IUpdateUserModel } from '.';

interface IUpdateUserProps {
  onSuccess: () => void;
  onClose: () => void;
  user: IUserDetails;
}

const items = { Admin: 'Admin', Employee: 'Employee' };

const UpdateUser: React.FC<IUpdateUserProps> = ({ onSuccess, onClose, user }) => {
  const dispatch = useAppDispatch();

  const formConfig = React.useMemo((): Record<string, DynamicFieldTypes> => ({
    name: {
      type: DynamicField.TEXT,
      required: true,
      name: 'name',
      title: 'Name',
      value: user?.name || '',
      disabled: false
    },
    email: {
      type: DynamicField.TEXT,
      inputType: 'email',
      required: true,
      name: 'email',
      title: 'Email',
      value: user?.email || '',
      disabled: false
    },
    role: {
      type: DynamicField.SELECT,
      required: true,
      name: 'role',
      title: 'Role',
      value: user?.role || '',
      disabled: false,
      items: items
    }
  }), [user]);

  const submit = React.useCallback(async (data: Record<string, any>) => {
    const payload: IUpdateUserModel = {
      id: user.id,
      name: data.name,
      email: data.email,
      role: data.role
    };

    const response = await DataService.post(
      'api/User/update',
      payload,
      undefined
    );

    if (response.ok) {
      onSuccess();
      return true;
    } else {
      const result: { message: string } = await response.json();
      dispatch(showAlert({
        message: result.message || 'An error occurred while updating user!',
        type: 'error'
      }));
      return false;
    }
  }, [dispatch, onSuccess, user]);

  return (
    <GenericDialog
      open={true}
      title="Edit User"
      onClose={onClose}
    >
      <DynamicFormWidget
        title=""
        fields={formConfig}
        onSubmit={submit}
      />
    </GenericDialog>
  );
};

export default UpdateUser;
